import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
import { Container, Eyebrow, Heading } from './Section';
import { Button } from './Button';
type Crumb = {
  name: string;
  path: string;
};
type Props = {
  eyebrow: string;
  title: React.ReactNode;
  lead: string;
  image: string;
  imageAlt: string;
  crumbs: Crumb[];
  ctaLabel: string;
  ctaService?: string;
  stats?: {
    value: string;
    label: string;
  }[];
};
export function PageHero({
  eyebrow,
  title,
  lead,
  image,
  imageAlt,
  crumbs,
  ctaLabel,
  ctaService,
  stats
}: Props) {
  return <section className="relative isolate overflow-hidden bg-graphite-900" data-id="element-464" data-mp="17bn9882ngl5j">
      <img src={image} alt={imageAlt} className="absolute inset-0 h-full w-full object-cover opacity-35" loading="eager" data-id="element-465" data-mp="12ck1gfvac0tv" />
      <div className="absolute inset-0 bg-graphite-900/70" aria-hidden="true" data-id="element-466" data-mp="xho6p7ynyzd2" />
      <Container className="relative py-14 md:py-20" data-id="element-467" data-mp="3n5xalu99cd2c">
        <nav aria-label="Ruta de navegación" className="flex flex-wrap items-center gap-1 text-xs text-mist-300" data-id="element-468" data-mp="3i59jz9oxxy8n">
          {crumbs.map((c, i) => <span key={c.path} className="flex items-center gap-1" data-id="element-469" data-mp="2t1xcbxairnjq" data-mpi={i}>
              {i > 0 && <ChevronRightIcon className="h-3 w-3 text-mist-300/60" aria-hidden="true" data-id="element-470" data-mp="2y2l4imahiafj" />}
              {i === crumbs.length - 1 ? <span className="text-white" data-id="element-471" data-mp="2o4x71olhuoto">{c.name}</span> : <Link to={c.path} className="transition-colors duration-150 hover:text-white" data-id="element-472" data-mp="2o708d4s3k4dp">
                  {c.name}
                </Link>}
            </span>)}
        </nav>

        <div className="mt-8 max-w-4xl" data-id="element-473" data-mp="2f6bt66qyvxz8">
          <Eyebrow tone="dark" data-id="element-474" data-mp="20g47li5nxyub">{eyebrow}</Eyebrow>
          <Heading as="h1" size="lg" tone="dark" className="mt-4 text-balance" data-id="element-475" data-mp="20d89ntttfa5v">
            {title}
          </Heading>
          <p className="mt-6 max-w-2xl text-lg leading-relaxed text-mist-200" data-id="element-476" data-mp="1remtu6fqa98s">{lead}</p>
          <div className="mt-9" data-id="element-477" data-mp="1rh0ncaurfde8">
            <Button to={ctaService ? `/contacto?servicio=${encodeURIComponent(ctaService)}` : '/contacto'} size="lg" withArrow trackingLocation="page-hero" className="bg-accent-500 text-graphite-900 hover:bg-accent-400" data-id="element-478" data-mp="1vgrl4yipets9">
              {ctaLabel}
            </Button>
          </div>
        </div>

        {stats && stats.length > 0 && <dl className="mt-14 grid gap-x-8 gap-y-8 border-t border-white/15 pt-9 sm:grid-cols-2 lg:grid-cols-4" data-id="element-479" data-mp="3jf27udujngpg">
            {stats.map(s => <div key={s.label} data-id="element-480" data-mp="ku0udickdkak">
                <dt className="sr-only" data-id="element-481" data-mp="fx0sljmqz3p9">{s.label}</dt>
                <dd data-id="element-482" data-mp="fv7ly4c4wjh9">
                  <span className="block font-display text-3xl font-bold tabular-nums text-white md:text-4xl" data-id="element-483" data-mp="axxjno3ncdc0">{s.value}</span>
                  <span className="mt-2 block text-xs uppercase tracking-[0.14em] text-mist-300" data-id="element-484" data-mp="6xdqswq3vvvo">{s.label}</span>
                </dd>
              </div>)}
          </dl>}
      </Container>
    </section>;
}